// Loading spinner bileşeni - Yükleme durumlarında gösterilir
import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = 'Yükleniyor...', fullScreen = true }) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  if (fullScreen) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className={`spinner ${sizeClasses[size]}`}></div>
        {text && (
          <p className="mt-4 text-gray-600 dark:text-gray-400 text-sm">
            {text}
          </p>
        )}
      </div>
    );
  }

  // Inline loading spinner - sayfa içinde kullanım için
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className={`spinner ${sizeClasses[size]}`}></div>
      {text && (
        <p className="mt-4 text-gray-600 dark:text-gray-400 text-sm">
          {text}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
